import { Type } from 'class-transformer';
import {
  IsNumber,
  IsOptional,
  IsUUID,
  Min,
  ValidateNested,
} from 'class-validator';

/**
 * One open-task category for a patient. `firstConditionId` is the oldest-acted
 * condition in the category — what a click on the category should open — and is
 * absent exactly when `count` is 0.
 */
export class ConditionOpenTaskCategoryDto {
  @IsNumber()
  @Min(0)
  count: number;

  @IsOptional()
  @IsUUID()
  firstConditionId?: string;
}

/**
 * A patient's open tasks. Counts are computed over the patient's whole condition
 * history, so they are unaffected by the page size of `POST /conditions/search`.
 */
export class ConditionOpenTasksDto {
  /**
   * Answers that have come back and still have to be passed on to the patient.
   * Biopsy answers count here too — the category covers everything the patient
   * page shows as `awaitingAction`, not e-consults alone.
   */
  @Type(() => ConditionOpenTaskCategoryDto)
  @ValidateNested()
  econsultsToReview: ConditionOpenTaskCategoryDto;

  @Type(() => ConditionOpenTaskCategoryDto)
  @ValidateNested()
  draftRegistrations: ConditionOpenTaskCategoryDto;

  @Type(() => ConditionOpenTaskCategoryDto)
  @ValidateNested()
  overdueFollowUps: ConditionOpenTaskCategoryDto;
}
